import React, { useState } from "react";
import { Stack, Chip } from "@mui/material";
import CustomInputs from "../../../../Component/DigitalMarketing/CustomInputs";
import useHandleChangeHooks from "../../../../hooks/digitalMarketing/useHandleChangeHooks";
import { useGetAllBranchesQuery } from "../../../../Service/Masters";
import {
  useCreateNewAppointmentMutation,
  useGetAllNewAppointmentsQuery,
  useGetConsultantListsQuery,
  useGetPatientDetailsByIdQuery,
  useGetPatientDetailsQuery,
  useGetTimeSlotsQuery,
} from "../../../../Service/appoinment";
import Tabs from "../../Customer/Component/Tabs";
import TimeSlotSelector from "./TimeSlotsComponent";
import CustomVioletButton from "../../../../Component/DigitalMarketing/CustomVioletButton";
import Toast from "../../../../Component/DigitalMarketing/Toast";
import useSnackbar from "../../../../hooks/digitalMarketing/useSnackbar";
import BackdropLoader from "../../../../Component/DigitalMarketing/BackDropLoader";

const AddAppointment = (props: any) => {
  const { setShowAppointment,refetchappoinment } = props;
  const [active, setActive] = useState(1);
  const [selectedTime, setSelectedTime] = useState(null);
  const [slotId, setSlotId] = useState(null);
  const { open, message, openSnackBar, type } = useSnackbar();
  const values = [
    { id: 1, name: "In Person" },
    { id: 2, name: "Virtual" },
  ];
  const checkboxInputs = [
    {
      type: "checkbox",
      checkBoxLabel: "Whatsapp",
      validation: "required",
    },
  ];

  const { formData, setFormData, handleChange, submit, setSubmit } =
    useHandleChangeHooks({});

  const [add, { isLoading: addLoading }] = useCreateNewAppointmentMutation();

  const { data: ConsultantData } = useGetConsultantListsQuery<any>({
    refetchOnMountOrArgChange: true,
  });
  const { data: patientData } = useGetPatientDetailsQuery<any>({
    refetchOnMountOrArgChange: true,
  });
  const { data: patient } = useGetPatientDetailsByIdQuery<any>(
    formData.customerId,
    {
      refetchOnMountOrArgChange: true,
      skip: !formData.customerId,
    }
  );
  const { data: timeSlots } = useGetTimeSlotsQuery(
    {
      id: formData.consultantId,
      date: formData.appointmentDate,
      type: active === 1 ? "in-Person" : "virtual",
    },
    {
      refetchOnMountOrArgChange: true,
      skip: !formData.appointmentDate && !formData.consultantId && !active,
    }
  );

  const { refetch } = useGetAllNewAppointmentsQuery({
    refetchOnMountOrArgChange: true,
  });

  const handleTimeSlotChange = (timeSlot) => {
    setSelectedTime(timeSlot.time);
    setSlotId(timeSlot.id);
  };

  const consultantOptions =
    Array.isArray(ConsultantData) && ConsultantData.length > 0
      ? ConsultantData?.map((b: any) => ({
          label: b.consultantName,
          value: b.id,
        })) || []
      : [];
  const patientOptions =
    patientData?.map((b: any) => ({
      label: b?.name,
      value: b?.customerId,
    })) || [];

  console.log(selectedTime, "selectedTime");
  const handleSubmit = async () => {
    setSubmit(true);
    const payload = {
      consultantId: formData.consultantId,
      customerId: formData.customerId,
      appointmentDate: formData.appointmentDate,
      appointmentTime: selectedTime,
      consultantSend: formData.consultantSend ? 1 : 0,
      patientSend: formData.patientSend ? 1 : 0,
      appointmentType: active === 1 ? "in-Person" : "virtual",
      reason: "",
      slotId: slotId,
    };

    try {
      await add(payload).unwrap();
      openSnackBar("Appointment Booked successfully");
      setTimeout(() => {
        setShowAppointment(false);
      }, 350);
      refetchappoinment();
    } catch (error) {
      console.error("Failed to book appointment: ", error);
    }
  };

  return (
    <>
      <BackdropLoader loader={addLoading} />
      <Toast open={open} type={type} message={message} />
      <div className="row">
        <div className="col-6 border-end">
          <Tabs tablist={values} active={active} setActive={setActive} />
          <CustomInputs
            label="Consultant Name"
            type="select"
            option={consultantOptions}
            labelKey="label"
            valueKey="value"
            validation="required"
            submit={submit}
            {...formData}
            onChange={handleChange}
            name="consultantId"
            setFormData={setFormData}
          />
          <CustomInputs
            label="Patient Name"
            type="select"
            option={patientOptions}
            labelKey="label"
            valueKey="value"
            validation="required"
            submit={submit}
            {...formData}
            onChange={handleChange}
            name="customerId"
            setFormData={setFormData}
          />
          {Array.isArray(patient) && (
            <div className="col-12">
              <CustomInputs
                label="Contact Number"
                type="normal"
                submit={submit}
                value={patient[0]?.phone_number}
                disabled={true}
                name="phone_number"
              />
            </div>
          )}
          <div className="row d-flex justify-content-between">
            {Array.isArray(patient) && (
              <div className="col-6">
                <CustomInputs
                  label="Gender"
                  type="normal"
                  submit={submit}
                  value={patient[0]?.sex}
                  disabled={true}
                  name="sex"
                />
              </div>
            )}
            {Array.isArray(patient) && (
              <div className="col-6">
                <CustomInputs
                  label="Date of Birth"
                  type="normal"
                  submit={submit}
                  value={patient[0]?.dateOfBirth}
                  disabled={true}
                  name="dateOfBirth"
                />
              </div>
            )}
          </div>
        </div>

        <div className="col-6">
          <CustomInputs
            {...formData}
            onChange={handleChange}
            type="date"
            label="Date"
            validation="required"
            submit={submit}
            name="appointmentDate"
            setFormData={setFormData}
          />
          <div className="mt-2 mb-2">
            <div>
              <span className="f-14 fw-500 fw-bold">Time Slot</span>
            </div>
            <TimeSlotSelector
              selectedTime={selectedTime}
              onTimeSlotChange={handleTimeSlotChange}
              timeSlots={timeSlots}
            />
          </div>
          <div className="mt-2 mb-2">
            <span className="f-14 fw-500 fw-bold">Send Notification</span>
          </div>

          <div className="p-2 rounded" style={{ backgroundColor: "#F6F6F6" }}>
            <div>
              <span className="f-12 fw-500 ms-2 fw-bold">To Consultant</span>
              <div className="d-flex gap-3">
                {checkboxInputs.map((config, index) => (
                  <CustomInputs
                    key={index}
                    {...formData}
                    onChange={handleChange}
                    submit={submit}
                    setFormData={setFormData}
                    {...config}
                    name="consultantSend"
                  />
                ))}
              </div>
              <hr />
              <span className="f-12 fw-500 ms-2 fw-bold">To Patient</span>
              <div className="d-flex gap-3">
                {checkboxInputs.map((config, index) => (
                  <CustomInputs
                    key={index}
                    {...formData}
                    onChange={handleChange}
                    submit={submit}
                    setFormData={setFormData}
                    {...config}
                    name="patientSend"
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="mt-3 d-flex gap-3 justify-content-end">
            <button
              type="submit"
              className={`btn btn border`}
              onClick={() => setShowAppointment(false)}
            >
              Cancel
            </button>
            <CustomVioletButton
              btnLabel="Book Appointment"
              onClick={handleSubmit} // Call handleSubmit on button click
              isLoading={addLoading} // Show loading state if the mutation is in progress
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AddAppointment;
